import { render, staticRenderFns } from "./AromaReportLogin.vue?vue&type=template&id=2ab639d8&scoped=true"
import script from "./AromaReportLogin.vue?vue&type=script&lang=js"
export * from "./AromaReportLogin.vue?vue&type=script&lang=js"
import style0 from "./AromaReportLogin.vue?vue&type=style&index=0&id=2ab639d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab639d8",
  null
  
)

export default component.exports